export const BASE_URL = "https://rgpv-forums-backend.onrender.com";
// export const BASE_URL = "http://localhost:5000";
